function wrap(value, min, max) {
  const range = max - min;
  return range > 0 ? ((value - min) % range + range) % range + min : 0;
}

export { wrap };
//# sourceMappingURL=wrap.js.map
